'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveUtmData = exports.parseUtmData = undefined;

var _UtmDataActionTypes = require('../actionTypes/UtmDataActionTypes');

var _PortalPropertiesDAO = require('../data/PortalPropertiesDAO');

var PortalPropertiesDao = _interopRequireWildcard(_PortalPropertiesDAO);

var _actionWithPayload = require('../utils/actionWithPayload');

var _actionWithPayload2 = _interopRequireDefault(_actionWithPayload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var parseUtmData = exports.parseUtmData = function parseUtmData(query) {
  return (0, _actionWithPayload2.default)(_UtmDataActionTypes.UTM_DATA_FETCHED, query);
};

var saveUtmData = exports.saveUtmData = function saveUtmData(utms, portalId) {
  return function () {
    var data = JSON.stringify(utms);
    return PortalPropertiesDao.save({ key: 'utms', portalId: portalId, data: data });
  };
};